import React from 'react';
import { createIcon } from '@chakra-ui/react';

const ArrowUpIcon = createIcon({
  displayName: 'ArrowUpIcon',
  viewBox: '4 4 15 15',
  path: (
    <>
      <path
        fill="currentColor"
        d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
      />
    </>
  ),
});

export default ArrowUpIcon;
